import template from '@/api/purchase-request/template'
import Vue from 'vue'

import { baseState, baseMutations } from '@/store/mixins'
import { join, isEmpty, split } from 'lodash'

export const state = {
    ...baseState,
    formViewDatas: {}
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    CLEAR_SETUP(state) {
        state.formViewDatas = {}
    },
    SET_VIEW_MODELS(state, { data, index }) {
        if (!index) {
            state.formViewDatas = data
        } else {
            split(index, ',').forEach(el => {
                Vue.set(state.formViewDatas, el, data[el])
            })
        }
    }
}

export const actions = {
    fetch(context, attributes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        )
        return template.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    store(context, data) {
        return template.store(data)
    },
    update(context, { id, data }) {
        return template.update(id, data)
    },
    async find(context, id) {
        let response = await template.find(id)
        context.commit('SET_EDIT_DATA', response.data)

    },
    destroy(context, id) {
        return template.destroy(id)
    },
    async getFormViewModel(context, { params, index }) {
        let response = await template.formViewModel({ params: params })
        context.commit('SET_VIEW_MODELS', {
            data: response.data,
            index: index
        })
        return Promise.resolve(response)
    }
}
